module.exports = __webpack_public_path__ + "img/20180404_171457-1.9617f5de.jpg";